/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PatientDto } from './PatientDto';
import {
    PatientDtoFromJSON,
    PatientDtoFromJSONTyped,
    PatientDtoToJSON,
    PatientDtoToJSONTyped,
} from './PatientDto';

/**
 * 
 * @export
 * @interface InstructionGenerationOutputDto
 */
export interface InstructionGenerationOutputDto {
    /**
     * Instruction ID
     * @type {string}
     * @memberof InstructionGenerationOutputDto
     */
    instructionId: string;
    /**
     * Instruction file path (generated by Gemini - DOCX format)
     * @type {object}
     * @memberof InstructionGenerationOutputDto
     */
    instructionTxtPath?: object;
    /**
     * Instruction file URL (generated by Gemini - DOCX format)
     * @type {object}
     * @memberof InstructionGenerationOutputDto
     */
    instructionTxtUrl?: object;
    /**
     * Instruction text generation token usage
     * @type {object}
     * @memberof InstructionGenerationOutputDto
     */
    instructionTxtTokenUsage?: object;
    /**
     * Instruction PDF file path
     * @type {object}
     * @memberof InstructionGenerationOutputDto
     */
    instructionPdfPath?: object;
    /**
     * Download URL for instruction file (DOCX) - signed URL for direct download (temporary, expires in 1 hour)
     * @type {object}
     * @memberof InstructionGenerationOutputDto
     */
    instructionPdfUrl?: object;
    /**
     * Instruction PDF generation token usage
     * @type {object}
     * @memberof InstructionGenerationOutputDto
     */
    instructionPdfTokenUsage?: object;
    /**
     * Timestamp when the instruction was created
     * @type {Date}
     * @memberof InstructionGenerationOutputDto
     */
    createdAt: Date;
    /**
     * Timestamp when the instruction was last updated
     * @type {Date}
     * @memberof InstructionGenerationOutputDto
     */
    updatedAt: Date;
    /**
     * Treatment plan ID
     * @type {object}
     * @memberof InstructionGenerationOutputDto
     */
    treatmentPlanId?: object;
    /**
     * 
     * @type {string}
     * @memberof InstructionGenerationOutputDto
     */
    language?: string;
    /**
     * Patient comments
     * @type {object}
     * @memberof InstructionGenerationOutputDto
     */
    patientComments?: object;
    /**
     * Additional comments
     * @type {object}
     * @memberof InstructionGenerationOutputDto
     */
    additionalComments?: object;
    /**
     * Feedback
     * @type {object}
     * @memberof InstructionGenerationOutputDto
     */
    feedback?: object;
    /**
     * Patient information
     * @type {PatientDto}
     * @memberof InstructionGenerationOutputDto
     */
    patient?: PatientDto;
    /**
     * Is generating
     * @type {boolean}
     * @memberof InstructionGenerationOutputDto
     */
    isGenerating?: boolean;
}

/**
 * Check if a given object implements the InstructionGenerationOutputDto interface.
 */
export function instanceOfInstructionGenerationOutputDto(value: object): value is InstructionGenerationOutputDto {
    if (!('instructionId' in value) || value['instructionId'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function InstructionGenerationOutputDtoFromJSON(json: any): InstructionGenerationOutputDto {
    return InstructionGenerationOutputDtoFromJSONTyped(json, false);
}

export function InstructionGenerationOutputDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): InstructionGenerationOutputDto {
    if (json == null) {
        return json;
    }
    return {
        
        'instructionId': json['instructionId'],
        'instructionTxtPath': json['instructionTxtPath'] == null ? undefined : json['instructionTxtPath'],
        'instructionTxtUrl': json['instructionTxtUrl'] == null ? undefined : json['instructionTxtUrl'],
        'instructionTxtTokenUsage': json['instructionTxtTokenUsage'] == null ? undefined : json['instructionTxtTokenUsage'],
        'instructionPdfPath': json['instructionPdfPath'] == null ? undefined : json['instructionPdfPath'],
        'instructionPdfUrl': json['instructionPdfUrl'] == null ? undefined : json['instructionPdfUrl'],
        'instructionPdfTokenUsage': json['instructionPdfTokenUsage'] == null ? undefined : json['instructionPdfTokenUsage'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'treatmentPlanId': json['treatmentPlanId'] == null ? undefined : json['treatmentPlanId'],
        'language': json['language'] == null ? undefined : json['language'],
        'patientComments': json['patientComments'] == null ? undefined : json['patientComments'],
        'additionalComments': json['additionalComments'] == null ? undefined : json['additionalComments'],
        'feedback': json['feedback'] == null ? undefined : json['feedback'],
        'patient': json['patient'] == null ? undefined : PatientDtoFromJSON(json['patient']),
        'isGenerating': json['isGenerating'] == null ? undefined : json['isGenerating'],
    };
}

export function InstructionGenerationOutputDtoToJSON(json: any): InstructionGenerationOutputDto {
    return InstructionGenerationOutputDtoToJSONTyped(json, false);
}

export function InstructionGenerationOutputDtoToJSONTyped(value?: InstructionGenerationOutputDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'instructionId': value['instructionId'],
        'instructionTxtPath': value['instructionTxtPath'],
        'instructionTxtUrl': value['instructionTxtUrl'],
        'instructionTxtTokenUsage': value['instructionTxtTokenUsage'],
        'instructionPdfPath': value['instructionPdfPath'],
        'instructionPdfUrl': value['instructionPdfUrl'],
        'instructionPdfTokenUsage': value['instructionPdfTokenUsage'],
        'createdAt': ((value['createdAt']).toISOString()),
        'updatedAt': ((value['updatedAt']).toISOString()),
        'treatmentPlanId': value['treatmentPlanId'],
        'language': value['language'],
        'patientComments': value['patientComments'],
        'additionalComments': value['additionalComments'],
        'feedback': value['feedback'],
        'patient': PatientDtoToJSON(value['patient']),
        'isGenerating': value['isGenerating'],
    };
}

